import React from 'react';
import PropTypes from 'prop-types';
import SaveStatus from './SaveStatus';

function Header(props) {
  return (
    <div
      className="bg-white border-top border-bottom mb-4"
      style={{ marginLeft: '-1.25rem', marginRight: '-1.25rem' }}
    >
      <div className="d-flex px-4 py-3 align-items-center mx-auto" style={{ maxWidth: '1250px', columnGap: '32px' }}>
        <div className="flex-grow-1 me-auto">
          <h1 className="my-1 fw-semibold" style={{ fontSize: '20px', lineHeight: 2 }}>Call for Experts / Products</h1>
        </div>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <SaveStatus {...props} />
      </div>
    </div>
  );
}

Header.propTypes = {
  lastSavedAt: PropTypes.number,
  lastSavedVersion: PropTypes.number.isRequired,
  savingError: PropTypes.oneOf([null, 'auto', 'manual']),
  savingState: PropTypes.string.isRequired,
  version: PropTypes.number.isRequired,
  timeNow: PropTypes.number.isRequired,
  requestStatus: PropTypes.oneOf(['draft', 'scheduled', 'posted']),
};

Header.defaultProps = {
  lastSavedAt: null,
  savingError: null,
  requestStatus: null,
};

export default Header;
